import { COMMON } from '@constants';
import { useFlow } from '@lib/pimster-flow/contexts/FlowContext';
import { Button, HStack, IconButton } from '@lib/uikit';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import {
    useProgressContext,
    useProgressDispatchContext,
} from '../../contexts/ProgressContext';

export const NavigationButtons: FC = () => {
    const { t } = useTranslation(COMMON);
    const { currentPageIndex, numberOfPages } = useProgressContext();
    const dispatch = useProgressDispatchContext();
    const { onPrevious, onNext } = useFlow();

    const handleNavigationPrevious = () => {
        if (currentPageIndex === 0) {
            return onPrevious();
        }

        dispatch({ type: 'PREVIOUS_PAGE' });
    };

    const handleNavigationNext = () => {
        if (currentPageIndex === numberOfPages - 1) {
            return onNext();
        }

        dispatch({ type: 'NEXT_PAGE' });
    };

    return (
        <HStack spacing='sm'>
            <IconButton
                colorScheme='white'
                variant='solid'
                color='black'
                onClick={handleNavigationPrevious}
                icon='chevron_left'
                ariaLabel='Previous'
            />
            <Button
                isFullWidth
                colorScheme='white'
                onClick={handleNavigationNext}
            >
                {t('continue')}
            </Button>
        </HStack>
    );
};
